import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { getProductos } from '../../services/ProductService';
import { addToCart } from '../../services/CartService';

import '../static/Inicio.css';
import '../static/Home.css';
import '../static/Productos.css';
import '../static/Global.css';
import '../static/Accordion.css';

import imagen1 from '../static/assets/collage1.jpg';
import imagen2 from '../static/assets/collage2.png';
import imagen3 from '../static/assets/collage3.jpg';
import imagen4 from '../static/assets/collage4.png';
import oscuraImg from '../static/assets/oscura.jpg';

function Inicio() {
  const [productos, setProductos] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [categoriaActiva, setCategoriaActiva] = useState('Todos');
  const [loading, setLoading] = useState(true);
  const [addedId, setAddedId] = useState(null);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  useEffect(() => {
    const fetchProds = async () => {
      try {
        const data = await getProductos();
        setProductos(data || []);
        setLoading(false);
      } catch (error) {
        console.error("Error cargando productos en Novatech:", error);
        setLoading(false);
      }
    };
    fetchProds();
  }, []);

  // Obtener categorías únicas para los tabs
  const categorias = ['Todos', ...new Set(productos.map(p => p.categoria).filter(Boolean))];

  // Filtrado de productos combinado
  const productosFiltrados = productos.filter(p => {
    const coincideCategoria = categoriaActiva === 'Todos' || p.categoria === categoriaActiva;
    const coincideBusqueda = busqueda.trim() === '' ||
      p.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
      p.descripcion?.toLowerCase().includes(busqueda.toLowerCase());

    return coincideCategoria && coincideBusqueda;
  });

  const handleAddToCart = (producto) => {
    addToCart(producto);
    setAddedId(producto.productos_id);
    setTimeout(() => setAddedId(null), 1500);
  };

  const scrollToCatalog = () => {
    const catalogElement = document.getElementById('catalogo-section');
    if (catalogElement) {
      catalogElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="inicio-modern">

      {/* ========================================================
          1. HERO SECTION DINÁMICO & MODERNO
          ======================================================== */}
      <section className="hero-modern">
        <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="4000">

          <div className="carousel-indicators">
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true"></button>
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2"></button>
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="3"></button>
          </div>

          <div className="carousel-inner">

            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="hero-slide-bg" style={{ backgroundImage: `url(${imagen1})` }}>
                <div className="hero-overlay"></div>
              </div>
              <div className="container hero-container">
                <div className="hero-content">
                  <span className="hero-badge">
                    <i className="fa-solid fa-shield-halved"></i> Seguridad Inteligente
                  </span>
                  <h1 className="hero-title">
                    Protege lo que más te importa al <span className="text-gradient">mejor precio</span>
                  </h1>
                  <p className="hero-description">
                    Soluciones avanzadas en videovigilancia, alarmas y monitoreo continuo para tu hogar y negocio con garantía certificada.
                  </p>
                  <div className="hero-cta-group">
                    <button onClick={scrollToCatalog} className="btn-modern-primary">
                      <i className="fa-solid fa-bag-shopping"></i> Explorar Catálogo
                    </button>
                    <Link to="/aboutus" className="btn-modern-glass">
                      <i className="fa-solid fa-headset"></i> Asesoría Gratuita
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="hero-slide-bg" style={{ backgroundImage: `url(${imagen2})` }}>
                <div className="hero-overlay"></div>
              </div>
              <div className="container hero-container">
                <div className="hero-content">
                  <span className="hero-badge">
                    <i className="fa-solid fa-microchip"></i> Alta Definición & IA
                  </span>
                  <h1 className="hero-title">
                    Cámaras 4K con <span className="text-gradient">Detección Humana</span>
                  </h1>
                  <p className="hero-description">
                    Visión nocturna a color, alertas instantáneas en tu smartphone y almacenamiento inteligente sin complicaciones.
                  </p>
                  <div className="hero-cta-group">
                    <button onClick={scrollToCatalog} className="btn-modern-primary">
                      <i className="fa-solid fa-cart-shopping"></i> Comprar Ahora
                    </button>
                    <Link to="/productos" className="btn-modern-glass">
                      <i className="fa-solid fa-layer-group"></i> Ver Modelos
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="hero-slide-bg" style={{ backgroundImage: `url(${imagen3})` }}>
                <div className="hero-overlay"></div>
              </div>
              <div className="container hero-container">
                <div className="hero-content">
                  <span className="hero-badge">
                    <i className="fa-solid fa-screwdriver-wrench"></i> Servicio Técnico
                  </span>
                  <h1 className="hero-title">
                    Instalación Profesional <span className="text-gradient">Garantizada</span>
                  </h1>
                  <p className="hero-description">
                    Técnicos certificados para Lima Metropolitana. Dejamos tu sistema 100% configurado y listo para monitorear.
                  </p>
                  <div className="hero-cta-group">
                    <button onClick={scrollToCatalog} className="btn-modern-primary">
                      <i className="fa-solid fa-bolt"></i> Cotizar Equipos
                    </button>
                    <Link to="/aboutus" className="btn-modern-glass">
                      <i className="fa-solid fa-phone"></i> Contactar Técnicos
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 4 */}
            <div className="carousel-item">
              <div className="hero-slide-bg" style={{ backgroundImage: `url(${imagen4})` }}>
                <div className="hero-overlay"></div>
              </div>
              <div className="container hero-container">
                <div className="hero-content">
                  <span className="hero-badge">
                    <i className="fa-solid fa-truck-fast"></i> Cobertura Nacional
                  </span>
                  <h1 className="hero-title">
                    Envíos Seguros a <span className="text-gradient">Todo el Perú</span>
                  </h1>
                  <p className="hero-description">
                    Despachamos por Olva Courier, Shalom y agencias de confianza con seguimiento en tiempo real.
                  </p>
                  <div className="hero-cta-group">
                    <button onClick={scrollToCatalog} className="btn-modern-primary">
                      <i className="fa-solid fa-cart-plus"></i> Ver Catálogo
                    </button>
                    <Link to="/reseñas" className="btn-modern-glass">
                      <i className="fa-solid fa-star"></i> Opiniones de Clientes
                    </Link>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <button className="carousel-control-prev modern-control" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
            <span className="carousel-control-icon-wrapper">
              <i className="fa-solid fa-chevron-left"></i>
            </span>
          </button>
          <button className="carousel-control-next modern-control" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
            <span className="carousel-control-icon-wrapper">
              <i className="fa-solid fa-chevron-right"></i>
            </span>
          </button>
        </div>
      </section>

      {/* ========================================================
          2. BARRA DE BENEFICIOS / VALOR AGREGADO
          ======================================================== */}
      <section className="features-strip">
        <div className="container">
          <div className="row g-4">

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon-box">
                  <i className="fa-solid fa-shield-halved"></i>
                </div>
                <div className="feature-text">
                  <h6>Garantía Oficial</h6>
                  <p>12 meses de respaldo directo</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon-box">
                  <i className="fa-solid fa-truck-fast"></i>
                </div>
                <div className="feature-text">
                  <h6>Envíos a Todo el Perú</h6>
                  <p>Shalom, Olva y Express</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon-box">
                  <i className="fa-solid fa-screwdriver-wrench"></i>
                </div>
                <div className="feature-text">
                  <h6>Soporte Técnico</h6>
                  <p>Instalación y configuración</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon-box">
                  <i className="fa-solid fa-credit-card"></i>
                </div>
                <div className="feature-text">
                  <h6>Pagos Seguros</h6>
                  <p>Yape, Plin y Transferencias</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ========================================================
          3. CATÁLOGO INTERACTIVO DE PRODUCTOS
          ======================================================== */}
      <section id="catalogo-section" className="catalog-section">
        <div className="container">

          {/* Header del Catálogo */}
          <div className="section-header text-center">
            <span className="section-subtitle">NUESTRA COLECCIÓN</span>
            <h2 className="section-title">Equipos y Dispositivos de Vanguardia</h2>
            <p className="section-desc">
              Selecciona una categoría o busca el modelo exacto que necesitas para tu instalación.
            </p>
          </div>

          {/* Filtros y Buscador */}
          <div className="catalog-controls">

            {/* Pestañas de Categoría */}
            <div className="category-pills-wrapper">
              <ul className="category-pills" role="tablist">
                {categorias.map(cat => (
                  <li key={cat}>
                    <button
                      className={`pill-btn ${categoriaActiva === cat ? 'active' : ''}`}
                      onClick={() => {
                        setCategoriaActiva(cat);
                        setBusqueda('');
                      }}
                      type="button"
                    >
                      {cat === 'Todos' ? (
                        <i className="fa-solid fa-border-all me-2"></i>
                      ) : (
                        <i className="fa-solid fa-tag me-2"></i>
                      )}
                      {cat}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Buscador Interactivo */}
            <div className="search-bar-container">
              <div className="search-input-wrapper">
                <i className="fa-solid fa-magnifying-glass search-icon"></i>
                <input
                  type="text"
                  className="search-input-field"
                  placeholder={`Buscar en ${categoriaActiva}...`}
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                />
                {busqueda && (
                  <button
                    className="clear-search-btn"
                    onClick={() => setBusqueda('')}
                    title="Limpiar búsqueda"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                )}
              </div>
            </div>

          </div>

          {/* Estado de Productos / Grid */}
          <div className="catalog-grid-wrapper pt-3">
            {loading ? (
              <div className="loader-wrapper">
                <div className="novatech-spinner"></div>
                <span className="loader-text">Cargando catálogo NovaTech...</span>
              </div>
            ) : productosFiltrados.length === 0 ? (
              <div className="no-products-box text-center py-5">
                <div className="no-products-icon">
                  <i className="fa-solid fa-box-open"></i>
                </div>
                <h4>No se encontraron productos</h4>
                <p className="text-muted">
                  No hay coincidencias para "<strong>{busqueda}</strong>" en la categoría <strong>{categoriaActiva}</strong>.
                </p>
                <button
                  className="btn-modern-primary mt-2"
                  onClick={() => { setCategoriaActiva('Todos'); setBusqueda(''); }}
                >
                  <i className="fa-solid fa-rotate-left"></i> Restablecer Filtros
                </button>
              </div>
            ) : (
              <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                {productosFiltrados.map((producto) => {
                  const isAdded = addedId === producto.productos_id;

                  return (
                    <div className="col" key={producto.productos_id}>
                      <div className="product-card">

                        {/* Categoría Badge */}
                        {producto.categoria && (
                          <span className="product-badge">
                            {producto.categoria}
                          </span>
                        )}

                        {/* Imagen del Producto */}
                        <div className="product-img-wrapper">
                          <img
                            src={producto.imagen}
                            className="img-fluid"
                            alt={producto.nombre}
                            loading="lazy"
                          />
                        </div>

                        {/* Contenido / Info */}
                        <div className="product-info">

                          <div className="name-row">
                            <h3 className="value" title={producto.nombre}>
                              {producto.nombre}
                            </h3>
                          </div>

                          <p className="text-muted small">
                            {producto.descripcion || 'Dispositivo de alta calidad con garantía oficial de NovaTech.'}
                          </p>

                          <div className="price-row">
                            <div>
                              <span className="label">Precio Online</span>
                              <span className="value">S/ {Number(producto.precio_venta).toFixed(2)}</span>
                            </div>

                            <div className="action-buttons-group" style={{ display: 'flex', gap: '8px' }}>
                              <button
                                className="view-details-btn"
                                onClick={() => setProductoSeleccionado(producto)}
                                title="Ver Detalles"
                              >
                                <i className="fa-solid fa-eye"></i>
                              </button>
                              <button
                                className={`buy-button ${isAdded ? 'added' : ''}`}
                                onClick={() => handleAddToCart(producto)}
                                title={isAdded ? "¡Añadido!" : "Añadir al Carrito"}
                              >
                                {isAdded ? (
                                  <i className="fa-solid fa-check"></i>
                                ) : (
                                  <i className="fa-solid fa-cart-plus"></i>
                                )}
                              </button>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </section>

      {/* ========================================================
          4. BANNER PROMOCIONAL / TECNOLOGÍA EN SEGURIDAD
          ======================================================== */}
      <section className="showcase-banner">
        <div className="container">
          <div className="showcase-card">
            <div className="row align-items-center g-5">

              <div className="col-12 col-lg-6">
                <div className="showcase-content">
                  <span className="showcase-badge">
                    <i className="fa-solid fa-bolt"></i> VIGILANCIA EN TIEMPO REAL
                  </span>
                  <h2 className="showcase-title">
                    Controla todo desde tu <span className="text-gradient">Smartphone</span>
                  </h2>
                  <p className="showcase-text">
                    Nuestras cámaras IP inteligentes cuentan con audio bidireccional, visión nocturna ultra nítida y notificaciones de movimiento directo a tu móvil 24/7.
                  </p>

                  <ul className="showcase-list">
                    <li>
                      <i className="fa-solid fa-circle-check text-accent"></i>
                      <span>Compatibilidad con iOS, Android y PC</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check text-accent"></i>
                      <span>Grabación local en tarjeta SD o en la Nube</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check text-accent"></i>
                      <span>Fácil configuración en menos de 5 minutos</span>
                    </li>
                  </ul>

                  <div className="showcase-actions mt-4">
                    <button onClick={scrollToCatalog} className="btn-modern-primary">
                      <i className="fa-solid fa-bag-shopping"></i> Comprar Kit de Seguridad
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <div className="showcase-image-box">
                  <img src={oscuraImg || imagen1} alt="Seguridad NovaTech" className="showcase-img" />
                  <div className="floating-stat-card">
                    <div className="stat-icon">
                      <i className="fa-solid fa-shield-virus"></i>
                    </div>
                    <div className="stat-info">
                      <h6>100% Protegido</h6>
                      <p>Soporte continuo NovaTech</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ========================================================
          5. SECCIÓN FAQ (PREGUNTAS FRECUENTES)
          ======================================================== */}
      <section className="faq-modern-section">
        <div className="container">

          <div className="section-header text-center">
            <span className="section-subtitle">RESOLVEMOS TUS DUDAS</span>
            <h2 className="section-title">Preguntas Frecuentes</h2>
            <p className="section-desc">
              Todo lo que necesitas saber antes y después de comprar tus equipos en NovaTech.
            </p>
          </div>

          <div className="faq-grid">

            <details className="faq-card">
              <summary className="faq-summary">
                <span>¿Las cámaras y equipos cuentan con garantía oficial?</span>
                <i className="fa-solid fa-chevron-down faq-arrow"></i>
              </summary>
              <div className="faq-body">
                Todos nuestros productos cuentan con garantía oficial por defectos de fábrica. Dependiendo de la marca y modelo, el periodo varía entre 6 a 12 meses. Entregamos boleta o factura con cada compra.
              </div>
            </details>

            <details className="faq-card">
              <summary className="faq-summary">
                <span>¿Hacen envíos a todas las provincias del Perú?</span>
                <i className="fa-solid fa-chevron-down faq-arrow"></i>
              </summary>
              <div className="faq-body">
                Sí, enviamos a todo el territorio nacional mediante agencias certificadas como Shalom, Olva Courier, Marvisur y agencias locales de tu preferencia, con número de seguimiento en tiempo real.
              </div>
            </details>

            <details className="faq-card">
              <summary className="faq-summary">
                <span>¿Cuáles son los métodos de pago disponibles?</span>
                <i className="fa-solid fa-chevron-down faq-arrow"></i>
              </summary>
              <div className="faq-body">
                Aceptamos transferencias bancarias directas (BCP, Interbank, BBVA), pagos móviles instantáneos con Yape y Plin, y pagos contraentrega previa coordinación en Lima.
              </div>
            </details>

            <details className="faq-card">
              <summary className="faq-summary">
                <span>¿Realizan instalaciones a domicilio en Lima?</span>
                <i className="fa-solid fa-chevron-down faq-arrow"></i>
              </summary>
              <div className="faq-body">
                Contamos con un equipo técnico especializado para instalaciones residenciales y comerciales en Lima Metropolitana y Callao. Coordinamos fecha y hora tras confirmar tu pedido.
              </div>
            </details>

            <details className="faq-card">
              <summary className="faq-summary">
                <span>¿Puedo realizar la instalación yo mismo?</span>
                <i className="fa-solid fa-chevron-down faq-arrow"></i>
              </summary>
              <div className="faq-body">
                La mayoría de nuestras cámaras Wi-Fi están diseñadas para instalación Plug & Play. Te brindamos guías en video y soporte remoto para que puedas configurarla en tu celular rápidamente.
              </div>
            </details>

          </div>

        </div>
      </section>

      {/* ========================================================
          6. BANNER FINAL CTA
          ======================================================== */}
      <section className="final-cta-section">
        <div className="container">
          <div className="cta-box text-center">
            <h2>¿Necesitas asesoría personalizada para tu proyecto?</h2>
            <p>Contáctanos hoy mismo y un especialista en seguridad te ayudará a elegir la mejor solución para tu presupuesto.</p>
            <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
              <Link to="/aboutus" className="btn-modern-primary">
                <i className="fa-solid fa-comments"></i> Contactar un Asesor
              </Link>
              <button onClick={scrollToCatalog} className="btn-modern-glass">
                <i className="fa-solid fa-magnifying-glass"></i> Ver Catálogo Completo
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ========================================================
          7. MODAL DE PRODUCTO
          ======================================================== */}
      {productoSeleccionado && (
        <div className="modern-modal-overlay" onClick={() => setProductoSeleccionado(null)}>
          <div className="modern-modal-content" onClick={e => e.stopPropagation()}>
            <button className="modern-modal-close" onClick={() => setProductoSeleccionado(null)}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className="modern-modal-body">
              <div className="modern-modal-image">
                <img src={productoSeleccionado.imagen} alt={productoSeleccionado.nombre} />
                {productoSeleccionado.categoria && (
                  <span className="modern-modal-badge">{productoSeleccionado.categoria}</span>
                )}
              </div>
              <div className="modern-modal-info">
                <h2>{productoSeleccionado.nombre}</h2>
                <p className="modern-modal-desc">
                  {productoSeleccionado.descripcion || 'Dispositivo de alta calidad con garantía oficial de NovaTech.'}
                </p>
                <div className="modern-modal-price-box">
                  <span className="label">Precio Online</span>
                  <span className="value">S/ {Number(productoSeleccionado.precio_venta).toFixed(2)}</span>
                </div>

                <div className="modern-modal-features">
                  <ul>
                    <li><i className="fa-solid fa-check text-accent"></i> Soporte técnico especializado</li>
                    <li><i className="fa-solid fa-check text-accent"></i> Envío a nivel nacional con seguro</li>
                    <li><i className="fa-solid fa-check text-accent"></i> ¡No te pierdas esta oportunidad!</li>
                  </ul>
                </div>

                <button
                  className="btn-modern-primary w-100 mt-4"
                  onClick={() => {
                    handleAddToCart(productoSeleccionado);
                    setProductoSeleccionado(null);
                  }}
                >
                  <i className="fa-solid fa-cart-plus"></i> Añadir al Carrito
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Inicio;
